import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";
import {useDewasListModel} from "@/stores/models/dewas-list-model";

export const useDewasListStore = defineStore(
    'dewasListStore',
    () => {
       
        const isLoading = ref(false);
        const dataSourceDewasList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDewasListModel().dewasListCustomStore,
                filter: ['dewas.is_dewas', '=', true],
            })
        );

        const dataSourceDewasSekreList = ref(
            new DataSource({
                requireTotalCount: true,
                store: useDewasListModel().dewasListCustomStore,
                filter: ['dewas.is_dewas', '=', false],
            })
        );

       




        const dataSourceDewasListCoba = (additionalParamsFilter = null, additionalParamsSort = null) => {
            return useDewasListModel().dewasListArray(additionalParamsFilter, additionalParamsSort);
        };

        const dataSourceDewasListUpdate = (key = null, values = null) => {
            return useDewasListModel().dewasListUpdate(key, values);
        };

        const dataSourceDewasListDelete = (key = null) => {
            return useDewasListModel().dewasListDelete(key);
        };
        
        const state = ref(true);
        const refresh =()=>{
            
            dataSourceDewasList.value.reload();
        };

        const initialized = ()=>{     
            dataSourceDewasList.value.reload();
        };

        return {
            dataSourceDewasList,
            dataSourceDewasSekreList,
            dataSourceDewasListCoba,
            dataSourceDewasListUpdate,
            dataSourceDewasListDelete,
            isLoading,
            refresh,
            initialized,
            state

        }
    }
);